import { IMachineSettingsDateFilter } from 'interfaces/i-machine-settings';
import { ErrorLevel } from 'lib_ts/enums/errors.enums';

/**
 * IErrorTableFilters is similar to the IErrorFilters we pass to the server, except:
 * - Booleans are replaced with StaticValues (True -> 'True', etc...) for internal and slack
 * - 'N/A' is provided as an additional option for level, internal, and slack
 * - '' used as a default value instead of undefined for internal, slack, and sender
 * - dateRange.start and dateRange.end use Date objects instead of ISO strings
 *
 * This is because our inputs don't take boolean or null values and we also want to provide users with a way
 * to filter specifically for errors that are missing a level, internal, or slack field (i.e. with 'N/A').
 *
 * We will coerce these values to the correct types before sending to the server
 * I.e. 'True' -> true, 'False' -> false, 'N/A' -> null, '' -> undefined, Date -> string
 */

export enum ErrorTableStaticValues {
  True = 'True',
  False = 'False',
  NA = 'N/A',
}

export type IErrorLevelWithNA = ErrorLevel | ErrorTableStaticValues.NA;

// Working type as used in the MachineErrors table. See IErrorsQuery for type sent to the server.
export interface IErrorTableFilters {
  dateRange?: IMachineSettingsDateFilter;
  level: IErrorLevelWithNA[];
  internal: ErrorTableStaticValues | '';
  slack: ErrorTableStaticValues | '';
  sender: string;
  errorTypeID: string;
}
